export class AppError {
  constructor (summary, detail) {
    this.summary = summary
    this.detail = detail
  }
}
